import React, { useEffect, useState } from "react";
import SideMenu from "../Pages/SideMenu";
import Header from "../Pages/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import Footer from "../Pages/Footer";
import Logout from "../Pages/Logout";
import { Button, Modal } from "react-bootstrap";
import { CustomTable } from "../CustomTable";
import { FarmOperation_getMasters, PloteLocationAdd, PloteLocationGet, } from "../Utilities/URLCONSTANTS";
import axios from "axios";
import { CustomModal } from "../CustomModal";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import { formatRoleName, modalCustomStyles } from "../Utilities/utils";
import Select from "react-select";


export const PloteLocationMaster = () => {
    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false)
    const [getLocation, setGetLocation] = useState([])
    const [name, setName] = useState()
    const [locationName, setLocationName] = useState()
    const [locationId, setLocationId] = useState()
    const [status, setStatus] = useState()
    const [id, setId] = useState()
    const [saveEdit, setSaveEdit] = useState()
    const [responseMsg, setResponseMsg] = useState()
    const [msgPopup, setMsgPopup] = useState(false)
    const [error, setError] = useState('')
    const [locationError, setLocationError] = useState('')
    const [statusError, setStatusError] = useState('')
    const [loader, setLoader] = useState(false)
    const [description, setDescription] = useState()

    const getData = async () => {
        const URL = PloteLocationGet;
        try {
            setLoader(true)
            const response = await axios.get(URL)
            setData(response.data.response)
            setLoader(false)
        } catch (error) {
            console.log(error)
        }
    }

    const LocationDropdown = async () => {
        const apiUrl = FarmOperation_getMasters;
        const headers = await GetApiHeaders();
        try {
            const response = await axios.get(apiUrl, { headers })
            setGetLocation(response.data.response.subSiteMaster)
        } catch (error) {
            console.log(error)
        }
    }

    const locationOptions = getLocation.map((item) => ({
        value: item.code, // or item.id, depending on your API
        label: item.name,
    }));

    useEffect(() => {
        getData()
        LocationDropdown()
    }, [])

    const headersData = [
        {
            field: "storeLocationId.name",
            header: "Sub Site",
        },
        {
            field: "name",
            header: "Plot Location Name",
        },

        {
            field: "createdBy.firstName",
            header: "Created By",
        },
        {
            field: "description",
            header: "Description",
        },

        {
            field: "active",
            header: "Status",
        },
    ];

    const onEditClicked = (data) => {
        setSaveEdit('Update')
        setId(data.id)
        setShowModal(true)
        setName(data.name)
        setDescription(data.description)
        setLocationName(data.storeLocationId.id)
        setStatus(data.active)
        setStatusError('')
        setError('')
        setLocationError('')
    }

    const handleModalOpen = () => {
        setSaveEdit('Submit')
        setShowModal(true)
        setName('')
        setLocationName('')
        setStatus('')
        setLocationId('')
        setDescription('')
        setStatusError('')
        setError('')
        setLocationError('')
    }
    const handleCancel_new = () => {
        setShowModal(false)
    }

    const handleName = (e) => {
        const Input = e.target.value
        // const alphanumericInput = Input.replace(/[^a-zA-Z0-9]/g, '');
        const formattedInput = formatRoleName(Input);
        setName(formattedInput)
        if (Input) {
            setError('')
        }
    }

    const handleLocation = (e) => {
        const locationInput = e.target.value
        setLocationName(locationInput)
        if (locationInput) {
            setLocationError('')
        }
    }


    const handleStatus = (e) => {
        setStatus(e.target.value);
        setStatusError("");
    };

    const handleDescription = (e) => {
        const Input = e.target.value
        // const formattedInput = formatRoleName(Input);
        const result = Input
            .replace(/\b[a-z]/g, (char) => char.toUpperCase());
        setDescription(result)
    }

    const handleSubmitData = async () => {
        const apiUrl = PloteLocationAdd;
        const reqData = {
            id: saveEdit === "Submit" ? 0 : id,
            name: name,
            storeLocationId: parseInt(locationName),
            description: description,
            status: status
        }
        const headers = await GetApiHeaders()
        try {
            if (!status) {
                setStatusError("Select Status")
            }
            if (!locationName) {
                setLocationError('Select Sub Site')
            }
            if (!name) {
                setError('Enter Plot Location')
            }
            if (name !== '' && locationName !== '' && status !== '') {
                setLoader(true)
                const response = await axios.post(apiUrl, reqData, { headers })
                if (response.data.statusCode == 200 || response.data.status == 500) {
                    setShowModal(false)
                    setMsgPopup(true)
                    setResponseMsg(response.data.message);
                    setLoader(false)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleOk = () => {
        setMsgPopup(false)
        getData()
    }

    return (
        <body id="page-top">
            <div id="wrapper">
                <SideMenu />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header />
                        <div>
                            <div className="container-fluid">
                                <div className="card border-0">
                                    <div className="card-body pt-0 pl-1">
                                        <h5 className="Roles_text">  Master</h5>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h6 className="mb-0 Sub_role_text"> Plot Location Master</h6>
                                            </div>
                                            <span class="d-inline-block" tabindex="0" data-toggle="tooltip" title="Add Plot Location Master"  >
                                                <Button variant="primary" className="buttons" onClick={handleModalOpen}  >
                                                    <FontAwesomeIcon icon={faPlus} className="plus_icon mr-1" />
                                                    Add
                                                </Button>
                                            </span>
                                        </div>
                                        <div className="mcrc_hrline"></div>
                                        <CustomTable
                                            headers={headersData}
                                            data={data}
                                            showAction={true}
                                            showButtons={true}
                                            ActionEdit={true}
                                            onEditClicked={onEditClicked}
                                            ActionName={"Action"}
                                            loader={loader}
                                            FileName={'Plot_Location'}
                                        />

                                        <CustomModal
                                            showModal={showModal}
                                            handleCancel_new={handleCancel_new}
                                            tittle={'Plot Location Master'}
                                            buttonText={saveEdit}
                                            handleSubmitData={handleSubmitData}
                                            childrens={
                                                <div>
                                                    <div className='row'>

                                                        <div className="col-md-6 col-12">
                                                            <label
                                                                htmlFor="subSiteDropdown"
                                                                className="form-label text-sm font-weight-600 mt-1"
                                                            >
                                                                Sub Site <span style={{ color: "red" }}>*</span>
                                                            </label>

                                                            <Select
                                                                inputId="subSiteDropdown"
                                                                styles={modalCustomStyles}
                                                                placeholder="Select Sub Site"
                                                                value={
                                                                    getLocation
                                                                        .map((item) => ({
                                                                            value: item.code,
                                                                            label: item.name,
                                                                        }))
                                                                        .find((option) => option.value === locationName) || null
                                                                }
                                                                options={getLocation.map((item) => ({
                                                                    value: item.code,
                                                                    label: item.name,
                                                                }))}
                                                                onChange={(selectedOption) =>
                                                                    handleLocation({
                                                                        target: {
                                                                            value: selectedOption ? selectedOption.value : "",
                                                                        },
                                                                    })
                                                                }
                                                                isClearable
                                                            />

                                                            <span style={{ color: "red" }}>
                                                                {locationError}
                                                            </span>
                                                        </div>
                                                        <div className='col-md-6 col-12' style={{ marginTop: "-4px" }}>
                                                            <label for="exampleInputPassword1" className="form-label text-sm font-weight-600 mt-1">
                                                                Plot Location <span style={{ color: "red" }}>*</span>
                                                            </label>
                                                            <div className="input-group input-group w-100">
                                                                <input type="text" className="form-control p-2 " maxLength={25} placeholder='Enter Plot Location Name' value={name} onChange={handleName} />
                                                            </div>
                                                            <span style={{ color: "red" }}> {error}</span>
                                                        </div>

                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-md-6 col-12 '>
                                                            <label for="exampleInputPassword1" className="form-label text-sm font-weight-600 mt-1">
                                                                Description
                                                            </label>
                                                            <div className="input-group input-group w-100">
                                                                <textarea class="form-control" style={{ height: 115 }} id="textAreaExample1" placeholder='Enter Description'
                                                                    rows="2" value={description} onChange={handleDescription} >
                                                                </textarea>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 col-12">
                                                            <label
                                                                htmlFor="statusDropdown"
                                                                className="form-label text-sm font-weight-600 mt-1"
                                                            >
                                                                Status <span style={{ color: "red" }}>*</span>
                                                            </label>

                                                            <Select
                                                                inputId="statusDropdown"
                                                                styles={modalCustomStyles}
                                                                placeholder="Select Status"
                                                                options={[
                                                                    { value: true, label: "Active" },
                                                                    { value: false, label: "In-Active" },
                                                                ]}
                                                                value={[
                                                                    { value: true, label: "Active" },
                                                                    { value: false, label: "In-Active" },
                                                                ].find(option => option.value === status) || null}
                                                                onChange={(selectedOption) =>
                                                                    handleStatus({
                                                                        target: {
                                                                            value: selectedOption ? selectedOption.value : "",
                                                                        },
                                                                    })
                                                                }
                                                                isClearable
                                                            />

                                                            <span style={{ color: "red" }}>{statusError}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        />
                                        <CustomModal
                                            showModal={msgPopup}
                                            msgPopup={msgPopup}
                                            handleOk={handleOk}
                                            handleCancel_new={handleCancel_new}
                                            tittle={'Plot Location Master'}
                                            childrens={<div className="p-4 d-flex justify-content-center" style={{ fontSize: "18px", color: "#4A7729", fontWeight: 500 }}>{responseMsg}</div>}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
            </a>
            <Logout />
        </body>
    )
}